export default "__VITE_ASSET__48aeff61__"